module.exports = __webpack_public_path__ + "11c710767891a57f4e5ce51af6877177.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_60.jpg
// module id = 1752
// module chunks = 5